const ApiEnum = {
    Api: process.env.REACT_APP_API_URL,
}

export default ApiEnum
